<template>

		<div class="pageBox topFixedSpace" id="pageBox" v-show="this.showPaper">
			<!--page start-->
			<div class="testing_analysis">
				<div class="headerEle clearfix">
					<div class="countEle fl">
						<span>正确 <strong>{{this.rightNum}}</strong></span> / {{this.totalNum}}题目
					</div>
					<!--
					<div class="fr filterBtn checkBoxItemEvent">
						仅看错题
					</div>
					-->
				</div>
				<div class="bodyEle">
					<!--题目 开始-->
					<div class="answerItem re" v-for="(question, idx) in questionList" v-show="curId === idx">
						<span class="answerNum ab radius50">{{idx+1}}</span>
						<h1>{{question.question_title}}</h1>
						<p v-for="option in question.option_info">{{option.option_key}}、{{option.option_text}}</p>

						<h2>以上说法正确的是：</h2>

						<ul>
							<!--
								li添加下面对应样式
								correct		真确
								error		错误
							-->
							<li class="re radius3 option" v-for="sel_option in question.option_select_info"  :class="{correct:sel_option.option_right == 1, error:sel_option.option_right == 0 && sel_option.option_selected == 1}" :opt_sel="sel_option.option_selected" :opt_rig="sel_option.option_right">
								<span class="selectItem ab radius2">{{sel_option.paper_option_key}}</span>
								<div class="infor">
									{{sel_option.paper_option_value}}
								</div>
							</li>


						</ul>
					</div>
					<!--题目 结束-->
				</div>
				<!--解析-->
				<div class="analysisBox">
					<div class="title">
						解析
					</div>
					<p v-for="(question, idx) in questionList" v-show="curId === idx">{{question.question_analysis ? question.question_analysis : '无解析'}}</p>
				</div>

				<div class="center btnGroup">
					<a class="pointer btnItem" v-on:click="preQuestion">上一题</a>
					<a class="pointer btnItem" v-on:click="nextQuestion">下一题</a>
				</div>

				<div class="cardSection clearfix">
					<img src="//images.jinku.com/newjk/h5/images/mobile/testing/cardIcon.png" class="fl cardIcon">
					<span class="fl pointer cardBtn cardBtnEvent active">答题卡</span>
				</div>
				<div class="cardListBox cardListEvent">
					<ul class="clearfix">
						<!--
							li状态样式控制
							correct		正确
							error		错误
						-->
						<li class="fl radius2 " v-for="(question, idx) in questionList" :class="{correct:question.is_right == 1, error:question.is_right == 0}">
							<a v-on:click="selQuestion(idx)">{{idx+1}}</a>
						</li>

					</ul>
				</div>

			</div>
			<!--page end-->
		</div>

</template>
<script>
    import http from "../../lib/http";
    import common from "../../lib/common";

    export default {
        name: 'DoPaper',
        data() {
            return {
                'token': '',
                'showPaper': false, //控制页面显示隐藏
                'curId': 0, //当前试题索引id
                'paperId': 0, //试卷id
                'rightNum': 0, //做对的试题数量
                'totalNum': 0, //总试题数量
                'questionList' : [], //问题list
            }
        },
        methods: {
            getPaperId:function(){
                var url = window.location.href;
                var param = url.split('?')[1];
                var paramArr = param.split('&');
                for (var num = 0; num < paramArr.length; num++){
                    var tmpArr = paramArr[num].split('=');
                    if (tmpArr[0] == 'paper_id'){
                        this.paperId = tmpArr[1];
                    }
                }
            },
            getPaperAnalysis:function () {
                let self = this;
                this.getPaperId();
                if (!this.paperId){
                    alert("试卷错误，请稍后重试");
                    this.$router.push('/');
                    return false;
                }
                this.token = common.getToken();
                //ajax 调用接口获取
                http({method: "post", url: "/org/exam/paper-analysis", data: "token="+encodeURIComponent(this.token)+"&paper_id="+this.paperId}).then(function (res) {
                    //处理登录返回结果
                    if (res.code == 0){ //
                        self.totalNum = res.data.paper_total;
                        self.rightNum = res.data.paper_right;
                        self.questionList = res.data.question_info;

                        //展示页面
                        self.showPaper = true;
                    } else { //接口错误，跳转到节点页面
                        alert("试卷错误，请稍后重试");
                        self.$router.push('/');
                    }
                }).catch(function (err) {
                    //处理结果异常捕获
                    alert("试卷错误，请稍后重试");
                    self.$router.push('/');
                });
            },
            nextQuestion:function () {
                if (this.curId < (this.totalNum - 1)){
                    this.curId += 1;
                }
            },
			preQuestion:function () {
				if (this.curId > 0){
                    this.curId -= 1;
				}
            },
            selQuestion:function (idx) {
                this.curId = idx;
            },

        },
        created(){
            this.getPaperAnalysis();
        },

    }


</script>
<style scoped>
@import "//images.jinku.com/newjk/h5/css/global_mobile.css";
@import "//images.jinku.com/newjk/h5/css/public.css";
@import "//images.jinku.com/newjk/h5/css/testing.css";
</style>



// WEBPACK FOOTER //
// src/components/exam/paper-analysis.vue